const swagger = {
    invalid_zod_type: '無效的 Zod 類型，請檢查路由 guard 配置。',
    not_supported_zod_type_for_params: '請求參數不支持的 Zod 類型，請檢查路由 guard 配置。',
};
export default swagger;
